// @flow

import React from 'react';
import { useMutation } from 'react-apollo';
import { useHistory } from 'react-router-dom';
import { useIntl } from 'react-intl';

import Form from './Form';
import PageHeader from '../PageHeader';
import LoadingIndicator from '../LoadingIndicator';
import PageButtons from '../PageButtons';
import useSelfEnrollment from '../../../hooks/useSelfEnrollment';
import useContactNumber from '../useContactNumber';
import usePath from '../usePath';
import useScrollToTop from '../useScrollToTop';

import { MESSAGES, PATHS, SCENARIOS } from '../constants';
import { VALIDATE_SELF_ENROLLMENT_PATIENT_IDENTITY } from '../mutations';

import styles from './styles.module.scss';

const IdentifyPatient = () => {
  useScrollToTop();
  const getPath = usePath();
  const history = useHistory();
  const { formatMessage } = useIntl();

  const [validateSelfEnrollment, { loading }] = useMutation(VALIDATE_SELF_ENROLLMENT_PATIENT_IDENTITY);
  const { setPatientData, setMessage, entityData } = useSelfEnrollment();

  const phoneNumber = useContactNumber();
  const { selfEnrollmentCobrandedLink = '' } = entityData?.selfEnrollment || {};

  const or = formatMessage({ id: 'app.self-enroll.identify.or' });
  const identifierNames = (entityData?.selfEnrollment?.selfEnrollmentPatientIdentifiers || []).map(
    (i) => i.identifierName,
  );
  const identifiers =
    identifierNames.length > 1
      ? `${identifierNames.slice(0, -1).join(', ')} ${or} ${identifierNames[identifierNames.length - 1]}`
      : identifierNames[0] || '';

  const handleOnSubmit = async (input) => {
    const result = await validateSelfEnrollment({ variables: { input } });

    const { data: { validateSelfEnrollmentPatientIdentity = {} } = {} } = result || {};
    const { message = '', patientInformation: patientData = null } = validateSelfEnrollmentPatientIdentity;
    setPatientData(patientData);
    setMessage(message);

    if (message === MESSAGES.PATIENT_FOUND || message === MESSAGES.ACCOUNT_PENDING_TO_BE_COMPLETED) {
      history.push(getPath(PATHS.FOUND));
    } else if (message.length) {
      history.push(getPath(PATHS.NOTIFY));
    }
  };

  return (
    <div className={styles.container}>
      <PageHeader
        headerId="app.self-enroll.identify.header"
        subHeaderId="app.self-enroll.identify.sub-header"
        values={{ identifiers }}
        headerVariant="d2"
      />
      {!loading ? <Form onSubmit={handleOnSubmit} loading={loading} /> : <LoadingIndicator />}
      <div className={styles.pageButtonsWrapper}>
        <PageButtons
          scenario={SCENARIOS.IDENTIFY}
          phoneNumber={phoneNumber}
          cobrandedLink={selfEnrollmentCobrandedLink}
        />
      </div>
    </div>
  );
};

export default IdentifyPatient;
